import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { keyBy } from "lodash";
import { computed, PropType, inject } from "vue";
import CompanyUpdateFormBasicFields from "./fields/CompanyUpdateFormBasicFields.vue";
import CompanyUpdateFormPersonsFields from "./fields/CompanyUpdateFormPersonsFields.vue";
import CompanyUpdateFormContactFields from "./fields/CompanyUpdateFormContactFields.vue";
import CompanyUpdateFormOtherFields from "./fields/CompanyUpdateFormOtherFields.vue";
import { CompanyFieldCategoryMap } from ".";
import provideCompanyFormInfo from "@/types/symbols/provideCompanyFormInfo";
import { CompanyDto } from "@api/company-dto";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyUpdateFormFields',
  props: {
	modelValue: {
		type: Object as PropType<CompanyDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const formInfo = inject(provideCompanyFormInfo);

const cats = computed(() => {
	return formInfo?.value?.fieldCategories || [];
});

const fieldsMap = computed(() => {
	return keyBy(cats.value, (r) => r.id) as unknown as CompanyFieldCategoryMap;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    ((fieldsMap.value.CompanyBasic?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(CompanyUpdateFormBasicFields, {
          key: 0,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: fieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true),
    ((fieldsMap.value.CompanyContactInfo?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(CompanyUpdateFormContactFields, {
          key: 1,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: fieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true),
    ((fieldsMap.value.CompanyOtherInfo?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(CompanyUpdateFormOtherFields, {
          key: 2,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: fieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true),
    ((fieldsMap.value.CompanyUpdatePersonsInfo?.fields ?? []).length > 0)
      ? (_openBlock(), _createBlock(CompanyUpdateFormPersonsFields, {
          key: 3,
          modelValue: formDataComputed.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed).value = $event)),
          fieldsMap: fieldsMap.value
        }, null, 8, ["modelValue", "fieldsMap"]))
      : _createCommentVNode("", true)
  ]))
}
}

})